// © Microsoft Corporation. All rights reserved.

/**
 * Attempts to parse a given string to a JSON object
 * @param {string} jsonString - The string to parse.
 * @returns {any} - the parsed object if successful, or null otherwise.
 */
export function tryParseJson(jsonString: string): any {
    try {
        return JSON.parse(jsonString);
    } catch {
        return null;
    }
}

/**
 * Attempts to parse the given value as a integer and if failed will return the defaultValue.
 * @param {string} value - The value to parse.
 * @param {number} defaultValue - The default value to return if parsing fails
 * @returns {number} the parsed value if it was a valid number or otherwise the default value if specified.
 */
export function tryParseInt(value: string, defaultValue: number): number {
    const n = parseInt(value);
    return isNaN(n) ? defaultValue : n;
}

/**
 * Attempts to convert the given JSON object to a string.
 * @param jsonObj - The JSON object to convert.
 * @returns {string} - the converted string if successful, or null otherwise.
 */
export function tryStringifyJson(jsonObj: {}): string {
    try {
        return JSON.stringify(jsonObj);
    } catch {
        return null;
    }
}
